import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../../../components/ui/common/dialog";

interface DocumentNotesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fileName?: string;
  note?: string;
}

/**
 * Read-only "Document notes" dialog opened from the "View notes" action in
 * `ImpactResultDocumentsReadOnly`. Shows the note attached to one supporting
 * document, or a fallback message when none was added.
 */
const DocumentNotesModal = ({ open, onOpenChange, fileName, note }: DocumentNotesModalProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="tw-max-w-md">
      <DialogHeader>
        <DialogTitle>Document notes</DialogTitle>
      </DialogHeader>
      <div className="tw-space-y-2">
        <p className="tw-text-sm tw-font-medium tw-text-foreground tw-break-all">{fileName}</p>
        <p className="tw-text-sm tw-text-muted-foreground">
          {note?.trim() ? note : "No note was added for this document."}
        </p>
      </div>
    </DialogContent>
  </Dialog>
);

export default DocumentNotesModal;
